import * as actionTypes from './actiontypes';
import { PAGE_LOADING, PAGE_LOADED } from '../page_details/actiontypes';
import * as API from './api';

export function updateSessionFlowFilter(payload, path) {
    return function (dispatch) {
        dispatch({
            type: actionTypes.UPDATE_SESSION_FLOW_FILTER,
            payload,
            path
        });
    };
}

export function getSessionFlowData(payload, callback) {
    return function (dispatch) {
        dispatch({
            type: PAGE_LOADING,
            payload: "session loading"
        });

        API.getSessionFlowData(payload, (error, response) => {
            if (!error) {
                dispatch({
                    type: actionTypes.SESSION_FLOW_LOADED,
                    payload: response,
                });
                if (callback) {
                    callback();
                }
            }
            dispatch({
                type: PAGE_LOADED,
            });
        });
    };
}



// WEBPACK FOOTER //
// ./src/data/redux/session_flow_details/actions.js